var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "DialogBase",
        {
          attrs: {
            title: "Thêm đại lý",
            visible: _vm.isOpenAddBrandDialog,
            width: "550px",
            "panel-icon": "el-icon-office-building",
            "panel-title": "ĐĂNG KÝ THÔNG TIN ĐẠI LÝ",
            "panel-subtitle":
              "Tạo mới một đại lý đại diện liên kết cổng thanh toán SePay cho nhà trường.",
            "confirm-loading": _vm.loading.submit,
            "confirm-text": "Lưu lại",
            "cancel-text": "Hủy bỏ",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isOpenAddBrandDialog = $event
            },
            "before-close": _vm.handleClose,
            cancel: _vm.handleClose,
            confirm: _vm.submitForm,
            open: _vm.handleOpen,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              staticClass: "modern-form",
              attrs: {
                model: _vm.formData,
                rules: _vm.rules,
                "label-position": "top",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: "Trường liên kết đại lý", prop: "idSchool" },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "full-width",
                      attrs: {
                        filterable: "",
                        placeholder: "Chọn trường học...",
                      },
                      on: { change: _vm.onSelectSchool },
                      model: {
                        value: _vm.formData.idSchool,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "idSchool", $$v)
                        },
                        expression: "formData.idSchool",
                      },
                    },
                    _vm._l(_vm.schoolList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: {
                          value: item.id,
                          label: `${item.id} - ${item.schoolName}`,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Tên đầy đủ đại lý", prop: "full_name" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "Nhập tên đầy đủ...",
                      maxlength: "200",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.formData.full_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "full_name", $$v)
                      },
                      expression: "formData.full_name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Tên viết tắt (mã nhận diện)",
                    prop: "short_name",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "Nhập tên viết tắt in hoa (A-Z, 0-9)...",
                      maxlength: "20",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.formData.short_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "short_name", $$v)
                      },
                      expression: "formData.short_name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Trạng thái khởi tạo", prop: "status" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "full-width",
                      attrs: { placeholder: "Chọn trạng thái", disabled: "" },
                      model: {
                        value: _vm.formData.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "status", $$v)
                        },
                        expression: "formData.status",
                      },
                    },
                    _vm._l(_vm.statusBrand, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }